
const bookmarksDataRight = [
    {
        id:"1",
        title:"3d Printing",
        url:"",
        img:"folder",
        children: [
            {
                id:"1-1",
                title:"Thingiverse",
                url:"https://www.thingiverse.com/", 
                img:"https://www.thingiverse.com/favicon.ico",
                children:""
            },
            {
                id:"1-2",
                title:"Thangs",
                url:"https://thangs.com/", 
                img:"https://thangs.com/favicon.ico",
                children:""
            },
            {
                id:"1-3",
                title:"Cults",
                url:"https://cults3d.com/", 
                img:"https://cults3d.com/favicon.ico",
                children:""
            },
            {
                id:"1-4",
                title:"Shapeways Marketplace",
                url:"https://www.shapeways.com/marketplace", 
                img:"https://www.shapeways.com/favicon.ico",
                children:""
            },
            {
                id:"1-5",
                title:"Shapeways Qoutes",
                url:"https://www.shapeways.com/model/material-configurator/upload", 
                img:"https://www.shapeways.com/favicon.ico",
                children:""
            },
        ]
    },
    {
        id:"2",
        title:"Magic the Gathering",
        url:"",
        img:"folder",
        children: [
            {
                id:"2-1",
                title:"Deck building management",
                url:"", 
                img:"folder",
                children: [
                    {
                        id:"2-1-1",
                        title:"Moxfield",
                        url:"https://www.moxfield.com/", 
                        img:"https://www.moxfield.com/favicon.ico",
                        children:""
                    },
                    {
                        id:"2-1-1",
                        title:"TappedOut",
                        url:"https://tappedout.net/", 
                        img:"https://tappedout.net/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"2-2",
                title:"Price History",
                url:"", 
                img:"folder",
                children: [
                    {
                        id:"2-2-1",
                        title:"MTG Stocks",
                        url:"https://www.mtgstocks.com/", 
                        img:"https://www.mtgstocks.com/favicon.ico",
                        children:""
                    },
                    {
                        id:"2-2-2",
                        title:"Set price DawnGlare",
                        url:"https://mtg.dawnglare.com/?p=sets", 
                        img:"https://mtg.dawnglare.com/favicon.ico",
                        children:""
                    },
                    {
                        id:"2-2-3",
                        title:"MTG Price",
                        url:"https://www.mtgprice.com/", 
                        img:"https://www.mtgprice.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"2-3",
                title:"MTGO",
                url:"", 
                img:"folder",
                children: [
                    {
                        id:"2-3-1",
                        title:"MTGO Beginner's Guide",
                        url:"https://www.cardhoarder.com/mtgo-beginner-guide", 
                        img:"https://www.cardhoarder.com/favicon.ico",
                        children:""
                    },
                    {
                        id:"2-3-2",
                        title:"Card Hoarder",
                        url:"https://www.cardhoarder.com/", 
                        img:"https://www.cardhoarder.com/favicon.ico",
                        children:""
                    },
                    {
                        id:"2-3-3",
                        title:"Goatbots",
                        url:"https://www.goatbots.com/", 
                        img:"https://www.goatbots.com/favicon.ico",
                        children:""
                    },
                    {
                        id:"2-3-4",
                        title:"Penny Dreadful",
                        url:"https://pennydreadfulmagic.com/", 
                        img:"https://pennydreadfulmagic.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"2-4",
                title:"Scryfall",
                url:"https://scryfall.com/", 
                img:"https://scryfall.com/favicon.ico",
                children:""
            },
            {
                id:"2-5",
                title:"EDHREC",
                url:"https://edhrec.com/", 
                img:"https://edhrec.com/favicon.ico",
                children:""
            },
            {
                id:"2-6",
                title:"cEDH decklist database",
                url:"https://cedh-decklist-database.com/", 
                img:"https://cedh-decklist-database.com/favicon.ico",
                children:""
            },
            {
                id:"2-7",
                title:"Mythic Spoiler",
                url:"http://mythicspoiler.com/newspoilers.html", 
                img:"http://mythicspoiler.com/favicon.ico",
                children:""
            },
            {
                id:"2-8",
                title:"What's in Standard?",
                url:"https://whatsinstandard.com/", 
                img:"https://whatsinstandard.com/favicon.ico",
                children:""
            },
            {
                id:"2-9",
                title:"Svenska Magic",
                url:"https://www.svenskamagic.com/", 
                img:"https://www.svenskamagic.com/favicon.ico",
                children:""
            },
        ]
    },
    {
        id:"3",
        title:"DIY",
        url:"",
        img:"folder",
        children: [
            {
                id:"3-1",
                title:"Choosing the right wall anchors",
                url:"https://www.finewoodworking.com/2021/07/19/choosing-the-right-wall-anchors", 
                img:"https://www.finewoodworking.com/app/themes/finewoodworking/favicon.ico",
                children:""
            }
        ]
    },        
]



export default bookmarksDataRight;